module.exports = new __parcel__URL__("crab.39812367.svg").toString();